import * as React from 'react'
import { cn } from '@/lib/utils'

// The one floating-panel look for every dropdown, popover, menu, and autocomplete
// list in the app. Call sites still own their own positioning (absolute / z / width /
// max-height / padding) — this fixes only the surface identity, which had drifted
// across rounded-lg vs rounded-xl and three different shadows.
export const MENU_SURFACE =
  'rounded-lg border border-[var(--fl-border)] bg-[var(--fl-surface)] shadow-[0_4px_20px_rgba(0,0,0,0.10)]'

export type MenuSurfaceProps = React.HTMLAttributes<HTMLDivElement>

export const MenuSurface = React.forwardRef<HTMLDivElement, MenuSurfaceProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn(MENU_SURFACE, className)} {...props} />
  )
)
MenuSurface.displayName = 'MenuSurface'
